import { Injectable } from '@angular/core';
import { Request, XHRBackend, RequestOptions, Response, Http, RequestOptionsArgs, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AuthenticatedHttpService extends Http {

  constructor(
    backend: XHRBackend,
    defaultOptions: RequestOptions,
    public authService: AuthService,
    public router: Router) {
    super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
/*    super.request(url, options).toPromise().then((res: any) => {
      if(res.json().errorCode == 2201){
        this.authService.logout();
        this.router.navigateByUrl('/login');
      }
    })*/

    // Only treat 401/403 as a session expiry for our own API. Third-party
    // absolute URLs (e.g. direct-to-S3 uploads) must not log the user out —
    // their errors propagate to the caller as normal request failures.
    const requestUrl = typeof url === 'string' ? url : url.url;
    const isApiRequest = requestUrl.indexOf(environment.apiUrl) === 0;

    return super.request(url, options).catch((error: Response) => {
            if (isApiRequest && (error.status === 401 || error.status === 403) && (window.location.href.match(/\?/g) || []).length < 2) {
                this.authService.logout();
                this.router.navigateByUrl('/login');
            }
            return Observable.throw(error);
        });

  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/auth-http.service.ts